import React, { Component } from 'react';
import { DISPATCH_ID } from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient/ApiClient";
import { connect } from "react-redux";
import {
    GeneralModal,
    EventModal,
    RoutesModal,
    Dashboard,
    CreateRouteSellers,
    UpdateRoute,
    DeleteRoute,
    ScheduleRoute
} from '../../components/index'
import { BreadCumb, NavBar } from "../../components";
import "./AdminView.css";
import '../../css/responsive.css'
import moment from 'moment';
import $ from 'jquery';
import config from "../../config";

import { RouteDocSellers, SellerRouteLine, SellerRouteEvent } from '../../components/NewOrder';
let apiClient = ApiClient.getInstance();

class AdminRoutesSellersView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            adminRoutes: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            view: 1,
            unassignedPartners: [],
            sellers: [],
            bisnessPartners: [],
            RouteDoc: new RouteDocSellers(),
            editedRoute: [],
            Waypoints: [],
            routes: [],
            routePoints: [],
            events: [],
            EventModel: new SellerRouteEvent(),
            calendarInfo: {},
            routeEvents: [],
            findedEvent: {},
            filteredRoutes: [],
            auxSeller: '',
            customersEvent: [],
            routesAction: 0,
            showRouteModal: false,
        };
    }

    async componentDidMount() {
        await this.GetRoutes();
        await this.GetRoutesEvents();
    }

    //#region ######### GENERAL OPERATIONS ##########################################################
    ChangeView = async (numView) => {
        const view = Number(numView);
        await this.setState({
            view,
            RouteDoc: new RouteDocSellers(),
            Waypoints: [],
        })
        if (view === 2 || view === 3) {
            await this.GetUnassignedPartners();
            await this.GetSellers();
        }
        if (view === 5) {
            await this.GetRoutesEvents();
        }
    }

    RefreshRouteDocModel = async (RouteDoc) => {
        await this.setState({ RouteDoc })
    }

    GetDiffTimes = (initTime, finalTime) => {
        let diffTimes = 0.00;
        let startTime = moment(initTime, "HH:mm:ss a");
        let endTime = moment(finalTime, "HH:mm:ss a");
        diffTimes = moment.duration(endTime.diff(startTime));
        return `Hrs: ${diffTimes.hours()} Min: ${diffTimes.minutes()} Sec: ${diffTimes.seconds()}`;
    }

    GetHannaDiff = (initTime, FinalTime) => {
        if (!initTime || !FinalTime) return "";
        // Parse the time strings into Date objects
        const date1 = new Date(initTime);
        const date2 = new Date(FinalTime);

        // Calculate the time difference in milliseconds
        const timeDifferenceMs = date2 - date1;

        // Convert the time difference to hours, minutes, and seconds
        const hours = Math.floor(timeDifferenceMs / 3600000);
        const minutes = Math.floor((timeDifferenceMs % 3600000) / 60000);
        const seconds = Math.floor((timeDifferenceMs % 60000) / 1000);

        // Format the result as "hh:mm:ss"
        const formattedDifference = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        return formattedDifference;
    }

    //#endregion

    //#region ######### CATALOGS ####################################################################
    GetSellers = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        let responseApi = await apiClient.GetSellers();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        this.setState({
            sellers: responseApi.data || []
        })
    }

    GetUnassignedPartners = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.getUnassignedPartners();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }

        this.setState({
            unassignedPartners: responseApi.data || []
        })
    }
    //#endregion

    //#region ######### INITIAL CONFIG ##############################################################
    GetRoutes = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true)
        const responseApi = await apiClient.getRoutes();
        enableSpinner(false)
        if (responseApi.status !== 1) {
            return showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
        }
        await this.setState({
            routes: responseApi?.data || []
        })
    }

    //#endregion

    //#region ######### CREATE ROUTE SELLERS ########################################################
    SaveRoute = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { RouteDoc, adminRoutes } = this.state
        RouteDoc.IdCreator = adminRoutes.USERID;
        RouteDoc.DocStatus = 'O';
        // return
        if (this.ValidateCreateRoute()) {
            enableSpinner(true)

            let responseApi = await apiClient.createNewRoute(RouteDoc);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
                return
            }
            showAlert({ type: 'success', message: `${responseApi.message}`, timeOut: 5000 });
            this.setState({
                RouteDoc: new RouteDocSellers(),
                Waypoints: [],
            })


            // await this.GetUnassignedPartners();
            await this.GetRoutes();
        }

    }

    ValidateCreateRoute = () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { RouteDoc, routes } = this.state
        if (RouteDoc.RoutesLines.length <= 0) {
            showAlert({ type: 'error', message: `NO PUEDE GENERARSE RUTAS SIN SOCIOS DE NEGOCIOS`, timeOut: 5000 });
            return false;
        }
        if (RouteDoc.RoutesLines.length === 1) {
            showAlert({ type: 'error', message: `SE NECESITA MAS DE 1 SOCIO DE NEGOCIOS PARA QUE SEA UNA RUTA`, timeOut: 5000 });
            return false;
        }
        if (RouteDoc.Code === '' || RouteDoc.Code === undefined) {
            showAlert({ type: 'error', message: `AUN NO REGISTRA EL CÓDIGO DE RUTA`, timeOut: 5000 });
            return false;
        }
        if (RouteDoc.Name === '' || RouteDoc.Name === undefined) {
            showAlert({ type: 'error', message: `AUN NO REGISTRA EL NOMBRE DE LA RUTA`, timeOut: 5000 });
            return false;
        }

        if (routes.length > 0) {
            for (let i = 0; i < routes.length; i++) {
                const route = routes[i];
                if (route.RouteCode === RouteDoc.Code) {
                    showAlert({ type: 'error', message: `ESTE CÓDIGO DE RUTA YA EXISTE. DEBES DE CAMBIARLO PARA PODER REGISTRAR LA RUTA.`, timeOut: 5000 });
                    return false;

                }
            }
        }
        return true;
    }

    AddPartnerToRoute = async (partner) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { RouteDoc, Waypoints } = this.state
        let pass = this.CheckIfIsInRoute(partner.CardCode, 1)

        if (pass === false) {
            let check = await this.CheckAddresses(partner);
            if (check.band === false) {
                showAlert({ type: 'error', message: `IMPOSIBLE AGREGAR A LA RUTA. NO CUENTA CON COORDENADAS`, timeOut: 5000 });
                return
            }
            // TO FILL THE ROUTE DOC
            let newRoute = JSON.parse(JSON.stringify(RouteDoc));
            let sellerRouteLine = new SellerRouteLine();
            sellerRouteLine.CardCode = partner.CardCode;
            sellerRouteLine.Address = check.customerCoordinates.addressName || '';
            sellerRouteLine.U_FMB_GPSLat = check.customerCoordinates.U_FMB_GPSLat;
            sellerRouteLine.U_FMB_GPSLon = check.customerCoordinates.U_FMB_GPSLon;

            newRoute.RoutesLines.push(sellerRouteLine);

            //TO FILL THE WAYPOINTS FOR THE MAP TOM TOM
            let newbusinessPartners = Waypoints.slice();
            if (newbusinessPartners.length > 0) {
                let ultimo = newbusinessPartners.pop();
                newbusinessPartners.push(
                    { lng: parseFloat(check.customerCoordinates.U_FMB_GPSLon), lat: parseFloat(check.customerCoordinates.U_FMB_GPSLat) },  // <- We start here
                )
                newbusinessPartners.push(ultimo);
            } else {
                let aux = { lng: parseFloat(check.customerCoordinates.U_FMB_GPSLon), lat: parseFloat(check.customerCoordinates.U_FMB_GPSLat) };
                newbusinessPartners.push(aux);
                newbusinessPartners.push(aux);
            }
            this.setState({
                RouteDoc: newRoute,
                Waypoints: newbusinessPartners
            })
        } else {
            showAlert({ type: 'info', message: `ESTE SOCIO YA ESTA AGREGADO A LA RUTA`, timeOut: 5000 });
        }
    }

    CheckIfIsInRoute = (cardCode, op) => {
        const { RouteDoc } = this.state
        let flag = false;
        switch (op) {
            case 1:
                if (RouteDoc.RoutesLines.length > 0) {
                    for (let i = 0; i < RouteDoc.RoutesLines.length; i++) {
                        const element = RouteDoc.RoutesLines[i];
                        if (element.CardCode === cardCode) {
                            flag = true;
                            return
                        }
                    }
                } else {
                    flag = false;
                }
                break;

            default:
                break;
        }
        return flag;
    }

    CheckAddresses = async (partner) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true)
        let responseApi = await apiClient.getAddressCoordinates(partner.CardCode || '');

        enableSpinner(false)
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        let addresses = responseApi.data;
        let customerCoordinates = {};
        let band = false;
        for (let i = 0; i < addresses.length; i++) {
            const address = addresses[i];
            if ((address.U_FMB_GPSLat !== null && address.U_FMB_GPSLat !== undefined) && (address.U_FMB_GPSLon !== null && address.U_FMB_GPSLon !== undefined)) {
                if (address.AdresType === "S") {
                    if (address.Address === partner.ShipToDef) {
                        customerCoordinates = {
                            addressName: address.Address,
                            U_FMB_GPSLat: address.U_FMB_GPSLat || '',
                            U_FMB_GPSLon: address.U_FMB_GPSLon || '',
                        }
                        band = true;
                    }
                }
            }
        }
        return {
            customerCoordinates: customerCoordinates,
            band: band
        }
    }

    DeleteRoutePartner = (index) => {
        const { RouteDoc, Waypoints } = this.state;
        let newRouteDoc = RouteDoc;
        let newbusinessPartners = Waypoints.slice();
        newRouteDoc.RoutesLines.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        newbusinessPartners.splice(index, 1)
        this.setState({ RouteDoc: newRouteDoc, Waypoints: newbusinessPartners });
    }
    //#endregion

    //#region ######### UPDATE ROUTE SELLERS ########################################################
    GetRoutePoints = async (route, fillRoute) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { view, adminRoutes } = this.state
        enableSpinner(true)
        let responseApi = await apiClient.getRoutePoints(route.Code);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }

        let points = [];
        for (let i = 0; i < responseApi.data.length; i++) {
            const element = responseApi.data[i];
            points.push({ lng: element.FMB_GPSLon, lat: element.FMB_GPSLat });
        }

        let primero = points[0];
        points.push(primero);
        this.setState({
            Waypoints: points || []
        })
        if (view === 3 || view === 4 || view === 5 || fillRoute) {
            this.FillRouteModel(route, adminRoutes, responseApi.data, points);
        }

    }

    FillRouteModel = (route, adminRoutes, routeLines, points) => {
        let RouteDoc = new RouteDocSellers();
        let arrayAux = [];
        // FILL LINES FOR ROUTE DOC 
        if (routeLines && routeLines.length > 0) {
            for (let i = 0; i < routeLines.length; i++) {
                const routeLine = routeLines[i];
                let routeLineModel = new SellerRouteLine();
                routeLineModel.RouteCode = routeLine.RouteCode;
                routeLineModel.LineNum = i;
                routeLineModel.CardCode = routeLine.CardCode
                routeLineModel.Address = routeLine.Address || '';
                routeLineModel.DocDate = routeLine.DocDate;
                routeLineModel.UpdateDate = moment().format('YYYY-MM-DD');
                routeLineModel.U_FMB_GPSLat = routeLine.FMB_GPSLat;
                routeLineModel.U_FMB_GPSLon = routeLine.FMB_GPSLon;
                arrayAux.push(routeLineModel);

            }
        }
        // FILL HEADER DOC
        RouteDoc.IdRegister = route.Code;
        RouteDoc.Code = route.RouteCode;
        RouteDoc.Name = route.RouteName;
        RouteDoc.IdCreator = route.USERID;
        RouteDoc.IdUpdateCreator = adminRoutes.USERID;
        RouteDoc.CreatedTime = route.Time;
        RouteDoc.SlpCode = route.SlpCode;
        RouteDoc.DocDate = route.DocDate;
        RouteDoc.UpdateDate = moment().format('YYYY-MM-DD');
        RouteDoc.Comment = route.Comments;
        RouteDoc.IsActive = route.IsActive;
        RouteDoc.DocStatus = route.DocStatus;
        RouteDoc.RoutesLines = arrayAux;
        this.setState({
            RouteDoc,
            Waypoints: points || [],
        })
    }

    SaveUpdatedRoute = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { RouteDoc } = this.state

        if (this.ValidateEditedRoute()) {
            enableSpinner(true)
            let responseApi = await apiClient.updateRoute(RouteDoc);
            enableSpinner(false)
            if (responseApi.status !== 1) {
                showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
                return
            }
            showAlert({ type: 'success', message: `${responseApi.message}`, timeOut: 5000 });

            this.setState({
                RouteDoc: new RouteDocSellers()
            })
            // await this.GetUnassignedPartners();
            await this.GetRoutes();
        }
    }

    ValidateEditedRoute = () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { RouteDoc } = this.state
        if (RouteDoc.Name === '' || RouteDoc.Name === undefined) {
            showAlert({ type: 'error', message: `NO PUEDES DEJAR EL NOMBRE DE LA RUTA VACIO`, timeOut: 5000 });
            return false;
        }
        if (RouteDoc.RoutesLines.length <= 0) {
            showAlert({ type: 'error', message: `NO ES POSIBLE GUARDAR RUTAS SIN SOCIOS DE NEGOCIOS`, timeOut: 5000 });
            return false;
        }
        if (RouteDoc.RoutesLines.length === 1) {
            showAlert({ type: 'error', message: `NO ES POSIBLE GUARDAR RUTAS CON 1 SOCIO DE NEGOCIOS`, timeOut: 5000 });
            return false;
        }
        return true;
    }

    DeleteEditedPartners = async (index, editDocLine) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { RouteDoc, Waypoints } = this.state
        enableSpinner(true)
        await apiClient.updateSAPRoute(editDocLine.CardCode);
        enableSpinner(false)
        let newEditDoc = RouteDoc;
        let newEditedRoute = Waypoints.slice();

        newEditDoc.RoutesLines.splice(index, 1);
        newEditedRoute.splice(index, 1);
        this.setState({ RouteDoc: newEditDoc, Waypoints: newEditedRoute });
        this.GetUnassignedPartners();
    }
    //#endregion

    //#region ######### DELETE ROUTE SELLERS ########################################################
    DeleteRoute = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { RouteDoc, adminRoutes } = this.state
        if (RouteDoc.Code === '') {
            showAlert({ type: 'error', message: `NO HAS SELECCIONADO UNA RUTA A ELIMINAR`, timeOut: 5000 });
        }
        RouteDoc.IdUpdateCreator = adminRoutes.USERID;
        enableSpinner(true)
        let responseApi = await apiClient.deleteRoute(RouteDoc);
        enableSpinner(false)
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        showAlert({ type: 'success', message: `${responseApi.message}`, timeOut: 5000 });

        this.setState({
            RouteDoc: new RouteDocSellers(),
            Waypoints: [],
        })
        // await this.GetUnassignedPartners();
        await this.GetRoutes();

    }
    //#endregion

    //#region ######### EVENTS ######################################################################
    RefreshEventModel = (EventModel) => {
        this.setState({ EventModel });
    }

    ChangeIdEvent = (value) => {
        const { EventModel } = this.state
        EventModel.Id = value;
        this.RefreshEventModel(EventModel);
    }

    ChangeNameEvent = (value) => {
        const { EventModel } = this.state
        EventModel.Title = value;
        this.RefreshEventModel(EventModel);
    }

    ChangeColorEvent = (value) => {
        const { EventModel } = this.state
        EventModel.Color = value;
        this.RefreshEventModel(EventModel);
    }

    ChangeRouteCodeEvent = (value) => {
        const { EventModel } = this.state
        EventModel.RouteCode = value;
        this.RefreshEventModel(EventModel);
    }

    GetRoutesEvents = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { routeEvents } = this.state;

        let newRouteEvents = routeEvents ? routeEvents.slice() : [];
        enableSpinner(true);
        const responseApi = await apiClient.getRoutesEvents();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        if (responseApi.data.length > 0) {
            newRouteEvents.length = 0;
            for (let i = 0; i < responseApi.data.length; i++) {
                const routeEvent = responseApi.data[i];
                let titleEvent = routeEvent.Title.trim() + " " + routeEvent.RouteCode.trim();
                let initDate = routeEvent.DateStart.split('T')
                let finalDate = routeEvent.DateEnd.split('T')

                newRouteEvents.push({
                    id: routeEvent.IdEVRO,
                    title: titleEvent,
                    start: initDate[0],
                    end: finalDate[0],
                    allDay: true,
                    backgroundColor: routeEvent.Color.trim(),
                });
            }
            this.setState({
                routeEvents: newRouteEvents
            })
        }
    }

    SaveEvent = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { EventModel } = this.state

        if (this.ValidateCreateEvent()) {
            enableSpinner(true);
            let responseApi = await apiClient.createNewRouteEvent(EventModel);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
                return
            }
            $('#generalModal').modal('hide');

            this.setState({
                EventModel: new SellerRouteEvent(),
            })

            showAlert({ type: 'success', message: `${responseApi.message}`, timeOut: 5000 });
            await this.GetRoutesEvents();

        }
    }

    getEventInfo = async (eventID) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        let responseApi = await apiClient.getEventInfo(eventID);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        await this.setState({
            findedEvent: responseApi.data.resultEvent[0] ?? {},
            customersEvent: responseApi.data.customersInfo ?? []

        })
        $('#EventModal').modal('show');

    }

    DeleteEvent = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { findedEvent } = this.state
        enableSpinner(true);
        let responseApi = await apiClient.deleteEvent(findedEvent.IdEVRO);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `ALGO SALIO MAL AL ELIMINAR EL REGISTRO`, timeOut: 5000 });
            return
        }
        $('#EventModal').modal('hide');
        await this.GetRoutesEvents();
    }

    ValidateCreateEvent = () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { EventModel } = this.state;
        if (this.ValidateIfExistEvent()) {
            if (EventModel.Id === '' || EventModel.Id === undefined) {
                showAlert({ type: 'error', message: `COMPLETA EL CAMPO ID`, timeOut: 5000 });
                return false;
            }
            if (EventModel.Title === '' || EventModel.Title === undefined) {
                showAlert({ type: 'error', message: `COMPLETA EL CAMPO TITULO DEL EVENTO`, timeOut: 5000 });
                return false;
            }
            if (EventModel.DateStart === '' || EventModel.DateStart === undefined) {
                showAlert({ type: 'error', message: `NO HAY FECHA DE INICIO`, timeOut: 5000 });
                return false;
            }
            if (EventModel.DateEnd === '' || EventModel.DateEnd === undefined) {
                showAlert({ type: 'error', message: `NO HAY FECHA DE FIN `, timeOut: 5000 });
                return false;
            }
            if (EventModel.RouteCode === '' || EventModel.RouteCode === undefined) {
                showAlert({ type: 'error', message: `NO HAS SELECCIONADO UNA RUTA`, timeOut: 5000 });
                return false;
            }
            return true;
        } else {
            showAlert({ type: 'error', message: `ESTE ID YA EXISTE. REGISTRA UN ID DIFERENTE`, timeOut: 5000 });
            return false;
        }
    }

    ValidateIfExistEvent = () => {
        const { EventModel, routeEvents } = this.state;
        for (let i = 0; i < routeEvents.length; i++) {
            const event = routeEvents[i];
            if (event.Id === EventModel.Id) {
                return false;
            }
        }
        return true;
    }



    //#endregion

    //#region ######### CALENDAR SPECIAL FUNCTIONS ##################################################
    handleDateSelect = async (selectInfo) => {
        await this.SetEventsDates(selectInfo);
        $('#generalModal').modal('show');
    }

    SetEventsDates = (selectInfo) => {
        const { EventModel } = this.state
        EventModel.DateStart = selectInfo.startStr;
        EventModel.DateEnd = selectInfo.endStr;
        this.setState({
            EventModel,
            calendarInfo: selectInfo.view.calendar
        });
    }

    handleEventClick = (clickInfo) => {
        this.getEventInfo(clickInfo.event.id)
    }

    renderEventContent = (eventInfo) => {
        return (
            <>
                <b>{eventInfo.timeText}</b>
                <i>{eventInfo.event.title}</i>
            </>
        )
    }
    //#endregion

    //#region ######### ROUTES ######################################################################
    OpenNewRoute = async () => {
        await this.setState({ routesAction: 1, showRouteModal: true, RouteDoc: new RouteDocSellers(), });
        $("#RoutesModal").modal("show");
        $("#RoutesModal").on("hidden.bs.modal", async () => {
            await this.setState({ routesAction: 0, showRouteModal: false });
        });
    }    

    OpenDetailsRoute = async (route) => {
        await this.GetRoutePoints(route, true);
        await this.setState({ routesAction: 2, showRouteModal: true });
        $("#RoutesModal").modal("show");
        $("#RoutesModal").on("hidden.bs.modal", async () => {
            await this.setState({ routesAction: 0, showRouteModal: false });
        });
    }

    updateRouteDoc = async (model) => {
        await this.setState({ RouteDoc: model, });
    }
    //#endregion

    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { itemsDashboard, view, unassignedPartners, RouteDoc, Waypoints, routes, routesAction, routeEvents, sellers } = this.state;
        const CalendarFunctions = {
            handleDateSelect: this.handleDateSelect,
            renderEventContent: this.renderEventContent,
            handleEventClick: this.handleEventClick
        }

        return (
            <div className="content">
                <NavBar props={this.props} itemsDashboard={itemsDashboard} />
                <BreadCumb subitem1={'ADMINISTRADOR DE RUTAS VENDEDORES'} url1={'#'} />
                <div style={{ marginLeft: "5rem", marginRight: "1rem", marginBottom: "5rem" }}>
                    <div className="row h3 mb-3"> ADMINISTRADOR DE RUTAS </div>
                    <Dashboard
                        Waypoints={Waypoints}
                        CalendarFunctions={CalendarFunctions}
                        Routes={routes}
                        OpenNewRoute={this.OpenNewRoute}
                        OpenDetailsRoute={this.OpenDetailsRoute}
                        OpenDetailsEvent={this.getEventInfo}
                        InitEvents={routeEvents}
                        view={view}
                        GetRoutePoints={this.GetRoutePoints} />
                </div>

                {/* <div style={{ marginLeft: "4.5rem" }}>
                    <h2 className="md-display-1">
                        <label id="linkOrdProv" className="text-muted">
                            &nbsp;ADMINISTRADOR DE RUTAS
                        </label>
                    </h2>
                </div>
                <div style={{ marginLeft: "4rem" }}>

                    {/* <select
                            onClick={(event) => this.ChangeView(event.target.value)}
                        >
                            <option value={1} >Dashboard</option>
                            <option value={2} >Crear ruta</option>
                            <option value={3} >Ver rutas</option>
                            <option value={4} >Eliminar rutas</option>
                            <option value={5} >Programar rutas</option>
                        </select> */}{/*
                    <ul className="nav nav-tabs md-tabs" id="myTabMD" role="tablist" style={{ position: "relative", zIndex: 1, padding: "0.7rem", marginRight: "1rem", marginBottom: "-20px", marginLeft: "1rem", backgroundColor: "#e9ecef", border: 0, borderRadius: "0.25rem" }}>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.ChangeView(1)}   >
                            <span className="nav-link show active" id="week-tab-md" data-toggle="tab" href="#week-md" role="tab" aria-controls="week-md" aria-selected="false" style={{ color: "gray" }}>General</span>
                        </li>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.ChangeView(2)} >
                            <span className="nav-link " id="mont-tab-md" data-toggle="tab" href="#mont-md" role="tab" aria-controls="mont-md" aria-selected="false" style={{ color: "gray" }}>Crear ruta</span>
                        </li>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.ChangeView(3)}>
                            <span className="nav-link " id="afterM-tab-md" data-toggle="tab" href="#afterM-md" role="tab" aria-controls="afterM-md" aria-selected="false" style={{ color: "gray" }}>Ver rutas</span>
                        </li>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.ChangeView(4)}>
                            <span className="nav-link " id="afterY-tab-md" data-toggle="tab" href="#afterY-md" role="tab" aria-controls="afterY-md" aria-selected="false" style={{ color: "gray" }}>Eliminar rutas</span>
                        </li>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.ChangeView(5)}>
                            <span className="nav-link " id="afterX-tab-md" data-toggle="tab" href="#afterX-md" role="tab" aria-controls="afterX-tab-md" aria-selected="false" style={{ color: "gray" }}>Programar rutas</span>
                        </li>
                    </ul>

                    {Number(view) === 1 &&
                        <Dashboard
                            Waypoints={Waypoints}
                            CalendarFunctions={CalendarFunctions}
                            Routes={routes}
                            InitEvents={routeEvents}
                            view={view}
                            GetRoutePoints={this.GetRoutePoints}
                        />
                    }
                    {Number(view) === 2 &&
                        <CreateRouteSellers
                            RouteDoc={RouteDoc}
                            Sellers={sellers}
                            Waypoints={Waypoints}
                            UnassignedPartners={unassignedPartners}
                            view={view}
                            DeleteRoutePartner={this.DeleteRoutePartner}
                            RefreshRouteDocModel={this.RefreshRouteDocModel}
                            SaveRoute={this.SaveRoute}
                            AddPartnerToRoute={this.AddPartnerToRoute}
                        />
                    }
                    {Number(view) === 3 &&
                        <UpdateRoute
                            RouteDoc={RouteDoc}
                            Waypoints={Waypoints}
                            Routes={routes}
                            Sellers={sellers}
                            UnassignedPartners={unassignedPartners}
                            view={view}
                            RefreshRouteDocModel={this.RefreshRouteDocModel}
                            GetRoutePoints={this.GetRoutePoints}
                            DeleteEditedPartners={this.DeleteEditedPartners}
                            SaveUpdatedRoute={this.SaveUpdatedRoute}
                            AddPartnerToRoute={this.AddPartnerToRoute}

                        />
                    }
                    {Number(view) === 4 &&
                        <DeleteRoute
                            RouteDoc={RouteDoc}
                            Routes={routes}
                            Waypoints={Waypoints}
                            view={view}
                            GetRoutePoints={this.GetRoutePoints}
                            DeleteRoute={this.DeleteRoute}
                        />
                    }
                    {Number(view) === 5 &&
                        <ScheduleRoute
                            InitEvents={routeEvents}
                            CalendarFunctions={CalendarFunctions}
                            />
                    }
                </div> */}

                <GeneralModal
                    title={this.TitleGeneralModal()}
                    body={this.BodyGeneralModal()}
                    footer={this.FooterModal()} />
                <EventModal
                    title={this.TitleEventModal()}
                    body={this.BodyEventModal()}
                    footer={this.FooterEventModal()} />

                {this.state.showRouteModal &&
                    <RoutesModal
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        routeDoc={RouteDoc}
                        action={routesAction}
                        
                        updateModel={this.updateRouteDoc}
                        addPartnerToRoute={this.AddPartnerToRoute}
                        deleteRoutePartner={this.DeleteRoutePartner}

                        saveRoute={this.SaveRoute}
                        saveUpdatedRoute={this.SaveUpdatedRoute}
                        deleteRoute={this.DeleteRoute} />
                }
            </div>

        );
    }

    //#region ######### AGREGAR EVENTO MODAL ############################################################ 
    TitleGeneralModal = () => {
        return (
            <div className='row'>
                <div className='col-md-12'>
                    <h4 className="modal-title" style={{ color: "#fff", fontWeight: "bold" }} id="exampleModalLabel">AGREGAR EVENTO</h4>
                </div>
            </div>
        );
    }

    BodyGeneralModal = () => {
        const { routes, EventModel } = this.state
        return (
            <>
                <div className=''>
                </div>
                <div className='row'>
                    <div className="col-lg-8 mb-4 order-0">
                        <div className="card">
                            <div className="d-flex align-items-end row">
                                <div className="col-sm-12">
                                    <div className="card-body">
                                        <h5 className="card-title text-primary">Crear Evento </h5>
                                        <div className='row'>
                                            <div className='col-sm-12'>
                                                <label htmlFor="exampleInputEmail1 ruta">ID del evento</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="ID del evento"
                                                    value={EventModel && EventModel.Id ? EventModel.Id : ''}
                                                    onChange={(event) => this.ChangeIdEvent(event.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-12'>
                                                <label htmlFor="exampleInputEmail1 ruta">Nombre del evento</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Nombre del evento"
                                                    value={EventModel && EventModel.Title !== '' ? EventModel.Title : ''}
                                                    onChange={(event) => this.ChangeNameEvent(event.target.value)}
                                                />

                                            </div>

                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-12'>
                                                <h5 className="card-title text-primary ruta">Color de la etiqueta </h5>
                                                <input
                                                    type="color"
                                                    id="colorpicker"
                                                    className='ml-2'
                                                    // value="#0000ff"
                                                    value={EventModel && EventModel.Color !== '' ? EventModel.Color : ''}
                                                    onChange={(event) => this.ChangeColorEvent(event.target.value)}
                                                />
                                                <label className="form-check-label" htmlFor="flexSwitchCheckChecked" style={{ paddingLeft: "1.5rem", textAlign: "center", paddingTop: ".5em" }}>Este color se mostarará en la etiqueta</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-6'>
                                                <h4 className="pr-2 ruta">Inicio :</h4>
                                                <input
                                                    type="date"
                                                    className="form-control col-md-6"
                                                    value={EventModel && EventModel.DateStart}
                                                    disabled={true}
                                                />

                                            </div>
                                            <div className='col-sm-6'>
                                                <h4 className="pr-2 ruta">Final :</h4>
                                                <input
                                                    type="date"
                                                    className="form-control col-md-6"
                                                    disabled={true}
                                                    value={EventModel && EventModel.DateEnd}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 order-2 mb-4">
                        <div className="card h-100">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h5 className="card-title m-0 me-2">Rutas activas</h5>
                                <div className="dropdown">
                                </div>
                            </div>
                            <div className="card-body scrollCardBP" >
                                <ul className="p-0 m-0">
                                    {routes && routes.map((route, index) => {
                                        return (
                                            route.IsActive === 1 &&
                                            <li key={`routeactive-${index}`} className={`d-flex mb-4 pb-1 ${EventModel.RouteCode === route.Code ? 'selected' : ''}`} onClick={() => this.ChangeRouteCodeEvent(route.Code)} >
                                                <div className="avatar flex-shrink-0 mr-2 ml-2 mt-2" style={{ maxHeight: "25px", maxWidth: "25px" }}>
                                                    <img
                                                        style={{ maxHeight: "25px", maxWidth: "25px" }}
                                                        src={require('../../images/ico/routeMap.png')} alt="User" className="rounded" />
                                                </div>
                                                <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                    <div className="me-2">
                                                        <small className="text-muted d-block mb-1">{route.RouteName}</small>
                                                        <h6 className="mb-0">{route.RouteCode} </h6>
                                                    </div>
                                                    <div className="user-progress d-flex align-items-center gap-1 mr-2">
                                                    </div>
                                                </div>
                                            </li>

                                        )
                                    })
                                    }

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        );
    }

    FooterModal = () => {
        return (
            <div className="d-flex flex-row-reverse ">
                <button type="button" className="btn btn-secondary ml-2" data-dismiss="modal">Cerrar</button>
                <button type="button" className="btn btn-success" onClick={() => this.SaveEvent()} >Agregar evento</button>

                {/* <button type="button" className="btn btn-primary" style={{ marginRight: "1vh" }}>Cambiar dirección</button> */}

            </div>

        );
    }
    //#endregion

    //#region ######### -EVENT MODAL ############################################################
    TitleEventModal = () => {
        return (
            <div className='row'>
                <div className='col-md-12'>
                    <h4 className="modal-title" style={{ color: "#fff", fontWeight: "bold" }} id="exampleModalLabel">DATOS DEL EVENTO</h4>
                </div>
            </div>
        );
    }

    BodyEventModal = () => {
        const { findedEvent, customersEvent } = this.state
        let dateStart = findedEvent && findedEvent.DateStart && findedEvent.DateStart.split('T') || '';
        let dateEnd = findedEvent && findedEvent.DateStart && findedEvent.DateEnd.split('T') || '';
        return (
            <div>
                <div className="content-wrapper">
                    <div className="container-fluid flex-grow-1 container-p-y">
                        <div className='row'>
                            <div className="col-12 mb-4 order-0">
                                <div className="card">
                                    <div className="d-flex align-items-end row">
                                        <div className="col-12">
                                            <div className="card-body">
                                                <h5 className="card-title text-primary">Evento </h5>
                                                <div className='row'>
                                                    <div className='col-12 col-sm-6'>
                                                        <label htmlFor="exampleInputEmail1">ID del evento</label>
                                                        <input
                                                            disabled={true}
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            aria-describedby="emailHelp"
                                                            value={findedEvent && findedEvent.IdEvent !== '' ? findedEvent.IdEvent : ''}

                                                        />
                                                    </div>
                                                    <div className='col-12 col-sm-6'>
                                                        <label htmlFor="exampleInputEmail1">Nombre del evento</label>
                                                        <input
                                                            disabled={true}
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            aria-describedby="emailHelp"
                                                            placeholder="Nombre del evento"
                                                            value={findedEvent && findedEvent.Title !== '' ? findedEvent.Title : ''}

                                                        />
                                                    </div>
                                                </div>
                                                <div className='row mt-1'>
                                                    <div className='col-12 col-sm-6'>
                                                        <h5 className="card-title text-primary">Color de la etiqueta </h5>
                                                        <input
                                                            disabled={true}
                                                            type="color"
                                                            id="colorpicker"
                                                            className='ml-2'
                                                            // value="#0000ff"
                                                            value={findedEvent && findedEvent.Color && findedEvent.Color.trim() !== '' ? findedEvent.Color.trim() : ''}
                                                        />
                                                        <label className="form-check-label" htmlFor="flexSwitchCheckChecked" style={{ paddingLeft: "1.5rem", textAlign: "center", paddingTop: ".5em" }}>Este color se muestra en la etiqueta del evento</label>
                                                    </div>
                                                    <div className='col-12 col-sm-6'>
                                                        <label htmlFor="exampleInputEmail1">Ruta asignada (código)</label>
                                                        <input
                                                            disabled={true}
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            aria-describedby="emailHelp"
                                                            placeholder="Nombre del evento"
                                                            value={findedEvent && findedEvent.RouteCode !== '' ? findedEvent.RouteCode : ''}

                                                        />

                                                    </div>
                                                </div>

                                                <div className='row mt-1'>
                                                    <div className='col-12 col-sm-6'>
                                                        <h4 className="pr-2 ruta">Inicio :</h4>
                                                        <input
                                                            disabled={true}
                                                            id="fechaInicio"
                                                            type="date"
                                                            className="form-control"
                                                            name="fechauno"
                                                            value={dateStart && dateStart[0] !== '' ? dateStart[0] : ''}

                                                        />

                                                    </div>
                                                    <div className='col-12 col-sm-6'>
                                                        <h4 className="pr-2 ruta">Final :</h4>
                                                        <input
                                                            disabled={true}
                                                            id="fechaInicio"
                                                            type="date"
                                                            className="form-control"
                                                            name="fechauno"
                                                            value={dateEnd && dateEnd[0] !== '' ? dateEnd[0] : ''}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 order-2 mb-4">
                                <div className="card h-100">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <h5 className="card-title m-0 me-2">CLIENTES ATENDIDOS</h5>
                                        <div className="dropdown"></div>
                                        </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                        <table id="noSalesReportTable" className="table table-striped scrolltable" style={{ fontSize: "1.2rem" }}>
                                            <thead style={{ textAlign: "-webkit-center" }}>
                                                <tr style={{ backgroundColor: "#0071bc", color: "white", fontSize: "1rem" }}>
                                                    <th scope="col-lg-auto"></th>
                                                    <th scope="col-lg-auto">CLIENTE</th>

                                                    <th scope="col-lg-auto">STATUS DE LA VISITA</th>
                                                    <th scope="col-lg-auto">NUMERO DE DOCUMENTO</th>
                                                    <th scope="col-lg-auto">TIPO DE DOCUMENTO</th>
                                                    <th scope="col-lg-auto">ID REPORTE DE NO VENTA</th>

                                                    <th scope="col-lg-auto">FECHA Y HORA DE LLEGADA</th>
                                                    <th scope="col-lg-auto">FECHA Y HORA DE SALIDA</th>
                                                    <th scope="col-lg-auto">TIEMPO DE VISITA.</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "-webkit-center" }} className='scrollCardBP'>

                                                {!!customersEvent && customersEvent.length > 0 && customersEvent.map((customer, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <th scope="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>
                                                                {customer?.Visited === '1' || customer?.Visited === 1 ?
                                                                    <img style={{ maxHeight: "2vh", maxWidth: "2vh" }} src={require('../../images/ico/check.png')} alt="checkIcon" className="rounded" />
                                                                    :
                                                                    <img style={{ maxHeight: "2vh", maxWidth: "2vh" }} src={require('../../images/ico/waiting.png')} alt="waitIcon" className="rounded" />}
                                                            </th>
                                                            <th scope="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{(customer?.CardCode) ?? ''}</th>
                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{customer?.Visited === 0 ? 'NO VISITADO' : 'VISITADO'}</td>
                                                            <th scope="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{customer?.DocNum === '' ? '----' : customer?.DocNum}</th>
                                                            <th scope="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{customer?.DocType === '' ? '----' : customer?.DocType}</th>
                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{customer?.IdReport === 0 ? '----' : customer?.IdReport}</td>

                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{customer?.InitTime || ''}</td>
                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{customer?.FinalTime || ''}</td>
                                                            {/* <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{'---'}</td> */}
                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{this.GetHannaDiff(customer?.InitTime || '', customer?.FinalTime || '')}</td>

                                                        </tr>)
                                                })}


                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>


                </div>
            </div>
            </div>
        );
    }

    FooterEventModal = () => {
        return (
            <div className="d-flex flex-row-reverse ">
                <button type="button" className="btn btn-info ml-2" data-dismiss="modal">Cerrar</button>
                <button type="button" className="btn btn-danger" onClick={() => this.DeleteEvent()} >Eliminar evento</button>
            </div>

        );
    }
    //#endregion

    ExistValue = (value) => {
        let returnedValue = '';
        if (value !== undefined || value !== undefined) {
            returnedValue = value;

        }
        return returnedValue;

    }
}

const mapStateToProps = store => {
    return {
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdminRoutesSellersView);